export const NUMBER_PATTERN = /\d+/;
